import { JobNoteOptionCascadableInterface } from '../interfaces/job-note-option-cascadable.interface';
import { PickType } from '@nestjs/swagger';
import { JobNoteOptionDto } from './job-note-option.dto';

export class JobNoteOptionCascadeDto
  extends PickType(JobNoteOptionDto, ['optionId'])
  implements JobNoteOptionCascadableInterface {}
